import React from 'react';
import LoadingSpinner from './LoadingSpinner';
import EmptyState from './EmptyState';

export default function DataTable({
  columns,      // [{ key, label, render, sortable, width }]
  data,
  loading,
  onRowClick,
  emptyIcon,
  emptyTitle,
  emptyAction,
  striped = true,
  hover = true,
  responsive = true,
}) {
  if (loading) return <LoadingSpinner />;
  if (!data || data.length === 0) return <EmptyState icon={emptyIcon} title={emptyTitle} action={emptyAction} />;

  const tableClass = ['table', 'table-sm', striped && 'table-striped', hover && 'table-hover', 'align-middle'].filter(Boolean).join(' ');

  // Caller can repeat the same `key` across columns when several columns read
  // from one source (e.g. nested `recordData`). Combining `key` with the
  // column index guarantees uniqueness for React's diff.
  const colKey = (col, idx) => `${col.key ?? 'col'}_${idx}`;

  return (
    <div className={responsive ? 'table-responsive' : ''}>
      <table className={tableClass}>
        <thead>
          <tr>
            {columns.map((col, idx) => (
              <th key={colKey(col, idx)} style={{ width: col.width }}>{col.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, i) => (
            <tr
              key={row._id || i}
              onClick={() => onRowClick && onRowClick(row)}
              style={onRowClick ? { cursor: 'pointer' } : {}}
            >
              {columns.map((col, idx) => (
                <td key={colKey(col, idx)}>
                  {col.render ? col.render(row[col.key], row) : (row[col.key] ?? '—')}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
